import { PRODUCT_DATA_STATISTICS, E_ROUTE_MAILMANAGEMENT, E_ROUTE_NOTICE_CENTER } from '@/router/routes/route.types';
export const ProductDataStatisticsRoutes = [
    {
        path: '/ProductDataStatistics/',
        name: PRODUCT_DATA_STATISTICS.PRODUCT_DATA_STATISTICS,
        component: () => import('../../views/productDataStatistics/ProductDataStatistics.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.DataAnalysis',
                    active: true,
                }
            ],
            permission: 'DataStatistics',
        },
        redirect: {
            name: PRODUCT_DATA_STATISTICS.PRODUCT_OVERVIEW,
        },
        children: [
            {
                path: '/ProductDataStatistics/overview',
                name: PRODUCT_DATA_STATISTICS.PRODUCT_OVERVIEW,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '59',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.overview',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/analytics',
                name: PRODUCT_DATA_STATISTICS.ANALYTICS,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '42',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.analytics',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            }, {
                path: '/ProductDataStatistics/eureka',
                name: PRODUCT_DATA_STATISTICS.EUREKA,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '36',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.eureka',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            }, {
                path: '/ProductDataStatistics/workspace',
                name: PRODUCT_DATA_STATISTICS.WORKSPACE,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '43',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.workspace',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            }, {
                path: '/ProductDataStatistics/backoffice',
                name: PRODUCT_DATA_STATISTICS.BACKOFFICE,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '46',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.backoffice',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            }, {
                path: '/ProductDataStatistics/bi',
                name: PRODUCT_DATA_STATISTICS.BI,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '56',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.bi',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            }, {
                path: '/ProductDataStatistics/insights',
                name: PRODUCT_DATA_STATISTICS.INSIGHTS,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                props(route) {
                    return {
                        dashboardId: '54',
                    };
                },
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.insights',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/features/2023/:dashboardId',
                name: `${PRODUCT_DATA_STATISTICS.FEATURE}2023`,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.feature2023',
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/features/2024/:dashboardId',
                name: `${PRODUCT_DATA_STATISTICS.FEATURE}2024`,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.feature2024',
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/features/2025/:dashboardId',
                name: `${PRODUCT_DATA_STATISTICS.FEATURE}2025`,
                component: () => import(/* webpackChunkName: "FeatureDataStatistics2025" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.feature2025',
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/features/2026/:dashboardId',
                name: `${PRODUCT_DATA_STATISTICS.FEATURE}2026`,
                component: () => import(/* webpackChunkName: "FeatureDataStatistics2026" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DataAnalysis',
                        },
                        {
                            text: 'backoffice.nav.dataStatistics.feature2026',
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/mail/:dashboardId',
                name: E_ROUTE_MAILMANAGEMENT.ANALYSIS,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.Mail',
                        },
                        {
                            text: 'backoffice.nav.data_analysis',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/resourceSpace/:dashboardId',
                name: E_ROUTE_MAILMANAGEMENT.ANALYSIS,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.productResourceSpaceManagement',
                        },
                        {
                            text: 'backoffice.nav.data_analysis',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            },
            {
                path: '/ProductDataStatistics/notice-center/:dashboardId',
                name: E_ROUTE_NOTICE_CENTER.NOTICE_DATA_ANALYSIS,
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/productDataStatistics/IframeView/overview/Overview.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.notifications',
                        },
                        {
                            text: 'backoffice.nav.data_analysis',
                            active: true,
                        }
                    ],
                    permission: 'SuperSet',
                },
            }
        ],
    }
];
